export default __webpack_public_path__ + "locales/sk/EmptyTrashDialog.json?hash=a396e0e352948a38116b042db3156e8a";